const DEBUG_KEY = 'app_debug_mode'

// Check if debugging is enabled via query string (?debug=true)
const isDebuggingFromQuery = () => {
  try {
    const params = new URLSearchParams(window.location.search)
    return params.get('debug') === 'true'
  } catch {
    return false
  }
}

// Check if debugging is enabled via localStorage
const isDebuggingFromLocalStorage = () => {
  try {
    return localStorage.getItem(DEBUG_KEY) === 'true'
  } catch {
    return false
  }
}

// Return true if debugging is enabled from any source
const isDebugMode = () => {
  return isDebuggingFromQuery() || isDebuggingFromLocalStorage()
}

export default {
  isDebuggingFromQuery,
  isDebuggingFromLocalStorage,
  isDebugMode
}
